import React from "react";

const Settings = () => {
  return <div>Some Settings here</div>;
};

export default Settings;
